export class EditorValid {
  static isEditorValid(html: string): boolean {
    const div = document.createElement('div');
    div.innerHTML = html;
    const textContent = div.textContent || div.innerText || '';
    return textContent.length === 0 || textContent.trim().length > 0;
  }
}
